import React from 'react';
import Helmet from 'react-helmet';

const TitleComponent = ({ title }) => {
    const defaultTitle = "Flo's Bibliothek";
    return (
        <Helmet>
            <title>{title ? title + " | " + defaultTitle  : defaultTitle}</title>
        </Helmet>
    );
};

export { TitleComponent };